import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Header.css";
import { useAuth } from "../context/AuthContext";
import { useMatter } from "../context/MatterContext";
import Avatar from "./Avatar";

const Header = () => {
  const navigate = useNavigate();
  const { isLoggedIn, signOut } = useAuth();
  const { party } = useMatter();

  const fullName = (() => {
    if (!party) return "";
    const direct = party?.partyName || party?.name;
    if (direct) return String(direct).trim();
    return [party?.firstName, party?.lastName].filter(Boolean).join(" ").trim();
  })();

  const handleSignOut = async () => {
    await signOut();
    navigate("/signin", { replace: true });
  };

  return (
    <header className="header">
      <div
        className="header-content pointer"
        onClick={() => navigate("/multimatters")}
      >
        <div className="header-logo">
          <img
            src="/images/pgmbm-logo-horizontal-white.png"
            srcSet="/images/pgmbm-logo-horizontal-white.png 1x, /images/pgmbm-logo-horizontal-white@2x.png 2x"
            width="229"
            height="120"
            alt="PGMBM"
            className="header-logo-img"
          />
        </div>
        {isLoggedIn && (
          <div className="header-actions">
            <button
              type="button"
              className="header-logout"
              onClick={handleSignOut}
            >
              Sair
            </button>
            {fullName && (
              <Avatar
                name={fullName}
                size={34}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/profile");
                }}
              />
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
